import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';
import { withRouter } from 'react-router-dom';
import { Button } from '@airtm/airtm-ui';
import IllustrationServerError from 'assets/images/sprite/illustration-server-error.svg';

const ServerError = function ({ t, history }) {
  return (
    <div className="content">
      <div className="container-fluid">
        <section className="section">
          <div className="row">
            <div className="col-sm-3 ml-auto">
              <p className="text--center">
                <img
                  className="img-fluid"
                  src={IllustrationServerError}
                  alt="server error illustration"
                />
              </p>
            </div>
            <div className="col-sm-9 col-lg-6 mr-auto">
              <div className="section__heading">
                <h1 className="font-weight--bold">{t('STATIC:SERVER_ERROR_TITLE')}</h1>
              </div>
              <div className="section__content">
                <h3>{t('STATIC:SERVER_ERROR_SUBTITLE')}</h3>
                <p>
                  <span>{t('STATIC:SERVER_ERROR_DETAILS')}</span>
                </p>
                <div className="btn-toolbar">
                  <Button variant="tertiary" onClick={() => history.goBack()}>
                    {t('STATIC:SERVER_ERROR_BACK')}
                  </Button>
                  <Button variant="primary" onClick={() => history.push('/')}>
                    {t('STATIC:SERVER_ERROR_LANDING')}
                  </Button>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </div>
  );
};

ServerError.propTypes = {
  t: PropTypes.func.isRequired,
  history: PropTypes.shape({
    goBack: PropTypes.func.isRequired,
    push: PropTypes.func.isRequired,
  }).isRequired,
};

export default withRouter(withTranslation('STATIC')(ServerError));
